var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultSpaceRoomFullBooked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 73,
    viewBox: "0 0 144 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.9153 71.2258C72.6874 71.5676 72.535 71.7953 72.4062 71.9549C72.2782 72.1137 72.2164 72.1488 72.1915 72.1591C72.1302 72.1846 72.0651 72.1973 72 72.1973C71.9349 72.1973 71.8698 72.1846 71.8085 72.1591C71.7836 72.1488 71.7218 72.1137 71.5938 71.9549C71.465 71.7953 71.3126 71.5676 71.0847 71.2258L70.0408 69.6599L69.9987 69.5967C69.4412 68.7603 69.1088 68.2615 68.6723 67.8746C67.3148 66.6713 65.5155 66.5001 64 66.5H12C5.64873 66.5 0.5 61.3513 0.5 55V12C0.5 5.64873 5.64872 0.5 12 0.5H72H132C138.351 0.5 143.5 5.64873 143.5 12V55C143.5 61.3513 138.351 66.5 132 66.5H80C78.4845 66.5001 76.6852 66.6713 75.3277 67.8746C74.8912 68.2615 74.5588 68.7603 74.0013 69.5967L73.9592 69.6599L72.9153 71.2258Z",
    fill: "#333333",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 138,
    height: 61,
    rx: 10,
    fill: "#EBEBEB",
    fillOpacity: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultSpaceRoomFullBooked);
export default __webpack_public_path__ + "static/media/default-space-room-full-booked.68d8648da549f9f88ed7305d75905b6d.svg";
export { ForwardRef as ReactComponent };